<template>
  <tr>

    <td class="img-row">
      <div class="img-wrapper">
        <img :src="this.imgFromType.find(o => o.type === task.type).iconImg" class="img-raised" :alt="task.title">
      </div>
    </td>
    <td class="text-left task-msg-body" style="font-size:16px;">{{task.veh}}</td>
    <td class="text-left task-msg-body" style="min-width:80px">{{task.date}}<div><p>{{task.time}}</p></div></td>
    <td class="text-left task-msg-body">{{task.title}}<div v-if="task.comment"><p>{{task.comment}}</p></div></td>
    <!-- <td class="td-actions text-right">
      <el-tooltip content="Edit" placement="top">
        <p-button type="info" aria-label="edit button" round icon class="btn-icon-mini btn-neutral" @click="handleEditClick">
          <i class="nc-icon nc-ruler-pencil"></i>
        </p-button>
      </el-tooltip>
      <el-tooltip placement="top" content="Remove">
        <p-button type="danger" aria-label="remove button" round icon class="btn-icon-mini btn-neutral" @click="handleDeleteClick">
          <i class="nc-icon nc-simple-remove"></i>
        </p-button>
      </el-tooltip>
    </td> -->
    <td>
      <p-checkbox v-model="task.done" @input="handleCheckUpdate">
      </p-checkbox>
    </td>
  </tr>
</template>
<script>
  import { Tooltip } from 'element-ui'

  export default {
    components: {
      [Tooltip.name]: Tooltip
    },
    data() {
        return {
            imgFromType : [
                {
                    type: 'INF',
                    iconImg: 'static/img/icons/icon-information.png'
                },
                {
                    type: 'ADV',
                    iconImg: 'static/img/icons/icon-warning.png'
                },
                {
                    type: 'ALE',
                    iconImg: 'static/img/icons/icon-alert.png'
                },
                {
                    type: 'URG',
                    iconImg: 'static/img/icons/icon-alert.png'
                }
            ]
        }
    },
    props: {
      task: {
        type: Object,
        default: () => {
          return {
            title: ''
          }
        }
      },
      index: Number
    },
    methods: {
      handleEditClick() {
        this.$emit('on-edit', this.index)
      },
      handleDeleteClick() {
        this.$emit('on-delete', this.index)
      },
      handleCheckUpdate(){
        this.$emit('on-ack', this.index)
      }
    }
  }
</script>
<style scoped>
.task-msg-body{
    font-weight: bolder;
}
</style>
